import { LiveEventRace } from 'services/api/database/EventService'

export const FrontRaceService = {
  isPerPersonSingleWithTeamRange: (race: LiveEventRace) =>
    race.raceSegments.length > 0 &&
    race.priceType === 'PER_PERSON' &&
    race.paymentCollectionType === 'SINGLE' &&
    !!race.minTeamSize &&
    (!race.maxTeamSize || race.maxTeamSize > race.minTeamSize),
  isPerPersonMultipleWithMinTeam: (race: LiveEventRace) =>
    race.priceType === 'PER_PERSON' &&
    race.paymentCollectionType === 'MULTIPLE' &&
    !!race.minTeamSize,
  displayPerParticipantLabel: (race: LiveEventRace) =>
    FrontRaceService.isPerPersonSingleWithTeamRange(race) ||
    FrontRaceService.isPerPersonMultipleWithMinTeam(race)
}
